export const KeyCodes = {
    COMMA: 188,
    ENTER: [10, 13],
}
